import { Link } from 'react-router'
import { cn } from '@/lib/utils'

export function LogoMark({ className }) {
  return (
    <img
      src="/brand/logo-64.png"
      srcSet="/brand/logo-64.png 1x, /brand/logo-128.png 2x, /brand/logo-192.png 3x"
      alt=""
      aria-hidden="true"
      width={32}
      height={32}
      className={cn('size-8 shrink-0 rounded-full bg-white', className)}
    />
  )
}

export function Logo({ to = '/', className }) {
  return (
    <Link to={to} className={cn('flex items-center gap-2 rounded-md', className)} aria-label="OneMentor home">
      <LogoMark />
      <span className="font-display text-lg font-bold tracking-tight">
        One<span className="text-primary">Mentor</span>
      </span>
    </Link>
  )
}
